const I18NextHttpBackend = require("i18next-http-backend/cjs")

/**
 * @type {import('next-i18next').UserConfig}
 */
module.exports = {
  // https://www.i18next.com/overview/configuration-options#logging
  debug: false,
  i18n: {
    localeDetection: false,
    defaultLocale: "vi",
    locales: ["en", "vi", "cs"],
  },
  ns: ["common"],
  defaultNS: "common",
  backend: {
    loadPath: "https://tamdaoc.eu/api/translations?ns=common&lng={{lng}}",
    requestOptions: {
      cache: "default",
      credentials: "same-origin",
      mode: "no-cors",
    },
  },
  serializeConfig: false,
  use: [I18NextHttpBackend],
  /** To avoid issues when deploying to some paas (vercel...) */
  // localePath: typeof window === "undefined" ? require("path").resolve("./public/locales") : "/locales",
  reloadOnPrerender: true,
  /**
   * @link https://github.com/i18next/next-i18next#6-advanced-configuration
   */
  saveMissing: true,
  saveMissingTo: "all",
  // updateMissing: true,
  // strictMode: true,
  // serializeConfig: false,
  // react: { useSuspense: false }
}
